import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import type { CompanyMembersScope } from './company-api';
import { CompanyMemberForm } from './CompanyMemberForm';
import { useCompanyScopeName } from './useCompanyScopeName';

interface CompanyMemberCreatePageProps {
  listPath: string;
  scope: CompanyMembersScope;
}

export function CompanyMemberCreatePage({ listPath, scope }: CompanyMemberCreatePageProps) {
  const companyName = useCompanyScopeName(scope);
  const scopeDescription = scope.type === 'targeted'
    ? `Entreprise ciblée : ${companyName ?? 'entreprise sélectionnée'}`
    : 'Entreprise active';

  return (
    <section className="flex w-full flex-col gap-6" data-testid="company-member-create-page">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl font-semibold tracking-tight text-foreground">Créer un membre</h1>
          <p className="text-sm leading-6 text-muted-foreground">{scopeDescription} · Choisissez le rôle du nouveau membre dans l’entreprise.</p>
        </div>
        <Button asChild variant="outline"><Link to={listPath}><ArrowLeftIcon data-icon="inline-start" />Retour aux membres</Link></Button>
      </div>
      <div className="overflow-hidden rounded-[var(--radius-surface-4xl)] border border-border/70 bg-card p-5 sm:p-6">
        <CompanyMemberForm listPath={listPath} scope={scope} />
      </div>
    </section>
  );
}
